module.exports = __webpack_public_path__ + "img/about-us.9239e9d0.jpg";